var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumSlot8 = function SvgNumSlot8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 76 90"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#num_slot_8_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#num_slot_8_svg__b)",
    d: "M21.662 79q-5.32 0-7.828-2.432-2.432-2.431-2.432-7.828V54.3q0-4.864 2.28-7.144 2.356-2.28 7.524-2.28v-4.484q-5.244 0-7.524-2.204t-2.28-7.22V21.24q0-5.32 2.432-7.752 2.431-2.508 7.828-2.508h32.604q5.396 0 7.828 2.432 2.508 2.431 2.508 7.828v9.728q0 5.015-2.356 7.22-2.28 2.205-7.448 2.204v4.484q5.168 0 7.448 2.28 2.355 2.28 2.356 7.144v14.44q0 5.32-2.432 7.828Q59.738 79 54.266 79zM50.01 66.688V48.6H25.994v18.088zm0-30.172V23.292H25.994v13.224z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "num_slot_8_svg__b",
    x1: 38,
    x2: 38,
    y1: 0,
    y2: 91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F34"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "num_slot_8_svg__a",
    width: 54.696,
    height: 69.516,
    x: 10.402,
    y: 9.98,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.496,
    dy: 0.496
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_299_12676"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_299_12676",
    result: "effect2_innerShadow_299_12676"
  })))));
};
export default SvgNumSlot8;